import { render, staticRenderFns } from "./AnamnesisContainer.vue?vue&type=template&id=f356be30&scoped=true"
import script from "./AnamnesisContainer.vue?vue&type=script&lang=js"
export * from "./AnamnesisContainer.vue?vue&type=script&lang=js"
import style0 from "./AnamnesisContainer.vue?vue&type=style&index=0&id=f356be30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f356be30",
  null
  
)

export default component.exports